import React, { Component } from 'react';
import styled from 'styled-components';
import ReportClientItem from './ReportClientItem';
import ReportTabArea from './ReportTabArea';
import TopMenu from './TopMenu';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import de from 'date-fns/locale/de';

const StyledList = styled.ul`
  margin: 0;
  width: 100%;
  padding: 24px 0;
  list-style-type: none;
`;

const GridAreaSidebar = styled.div`
  margin: 0;
  padding: 0;
  min-width: 300px;
  min-height: 0;
  overflow: auto;
  grid-area: sidebar;
  color: rgba(255, 255, 255, 0.8);
  background-color: #00024e;
  font-size: 16px;
  font-family: latolight;
  box-sizing: border-box;

  @media print {
    display: none !important;
  }
`;

const GridAreaContent = styled.div`
  grid-area: content;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  min-width: 0;
  min-height: 0;

  @media print {
    left: 0px;
    top: 100px;
    position: absolute;
    width: 100%;
  }
`;

class ReportTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReportId: -1,
      selectedReportVersionString: '-1',
      selectedReportPageId: -1,
      selectedReportTabId: -1,
      reportsVersions: null
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (
      state.selectedReportId !== props.selectedReportId ||
      state.selectedReportVersionString !== props.selectedReportVersionString ||
      state.selectedReportPageId !== props.selectedReportPageId ||
      state.selectedReportTabId !== props.selectedReportTabId
    ) {
      let stateUpdate = {
        selectedReport: props.reports.find(
          report => report.id === props.selectedReportId
        ),
        selectedReportVersionString: props.selectedReportVersionString
      };
      stateUpdate.selectedReportPage = stateUpdate.selectedReport.pages.find(
        page => page.id === props.selectedReportPageId
      );
      stateUpdate.selectedReportTab = stateUpdate.selectedReportPage.tabs.find(
        tab => tab.id === props.selectedReportTabId
      );

      if (state.reportsVersions) {
        let reportVersion = state.reportsVersions.find(
          reportVersion => reportVersion.id === stateUpdate.selectedReport.id
        );
        reportVersion.versionString = stateUpdate.selectedReportVersionString;
        reportVersion.version = stateUpdate.selectedReport.data_provider.versions.find(
          version => version.version === stateUpdate.selectedReportVersionString
        );
      } else {
        stateUpdate.reportsVersions = [];
        props.reports.forEach(report => {
          report.id === stateUpdate.selectedReport.id
            ? stateUpdate.reportsVersions.push({
                id: stateUpdate.selectedReport.id,
                versionString: stateUpdate.selectedReportVersionString,
                version: stateUpdate.selectedReport.data_provider.versions.find(
                  version =>
                    version.version === stateUpdate.selectedReportVersionString
                )
              })
            : stateUpdate.reportsVersions.push({
                id: report.id,
                version: report.data_provider.versions[0],
                versionString: report.data_provider.versions[0].version
              });
        });
      }

      return stateUpdate;
    }

    return null;
  }

  render() {
    const selectedReportId = this.state.selectedReport.id;
    const selectedReportVersionString = this.state.selectedReportVersionString;
    const selectedReportPageId = this.state.selectedReportPage.id;
    const selectedReportTabId = this.state.selectedReportTab.id;
    const { reports, apiEndpoint } = this.props;
    const selectedReportVersion = this.state.selectedReport.data_provider.versions.find(
      version => version.version === selectedReportVersionString
    );
    const reportsByClient = reports.reduce((acc, report) => {
      const client = report.data_provider.client;
      const clientGroup = acc.find(group => group.client === client);
    
      if (clientGroup) {
        clientGroup.reports.push(report);
      } else {
        acc.push({ client: client, reports: [report] });
      }
      return acc;
    }, []);

    reportsByClient.sort((a, b) => a.client.localeCompare(b.client));

    document.title =
      this.state.selectedReport.name +
      ' - ' +
      this.state.selectedReportPage.name +
      (this.state.selectedReportPage.tabs.length > 1
        ? ' - ' + this.state.selectedReportTab.name
        : '') +
      ` [${selectedReportVersion.short_description}]`;

    return (
      <React.Fragment>
        <TopMenu
          versionSwitcher={this.props.versionSwitcher}
          history={this.props.history}
          report={this.state.selectedReport}
          selectedReportId={selectedReportId}
          selectedReportPageId={selectedReportPageId}
          selectedReportTabId={selectedReportTabId}
          selectedReportVersionString={selectedReportVersionString}
        />
        <GridAreaSidebar>
          <StyledList>
            {reportsByClient.map(reportClient => {
              const reportIds = reportClient.reports.map(report => report.id);
              const reportsVersions = this.state.reportsVersions.filter(
                reportVersion => reportIds.includes(reportVersion.id)
              );
              return (
                <ReportClientItem
                  key={`rci-${reportClient.reports[0].id}`}
                  reportClient={reportClient}
                  reportsVersions={reportsVersions}
                  selectedReportId={selectedReportId}
                  selectedReportPageId={selectedReportPageId}
                  selectedReportTabId={selectedReportTabId}
                />
              );
            })}
          </StyledList>
        </GridAreaSidebar>
        <GridAreaContent>
          {reports.map(report => {
            let version = this.state.reportsVersions.find(
              reportVersion => reportVersion.id === report.id
            ).version;
            return report.pages.map(page =>
              page.tabs.map(tab => (
                <ReportTabArea
                  key={`${report.id}__${version.version}__${page.id}__${
                    tab.id
                  }`}
                  reportName={report.name}
                  reportVersionString={version.version}
                  reportLastUpdated={format(
                    parse(version.data_from),
                    'DD.MM.YYYY',
                    {
                      locale: de
                    }
                  )}
                  reportPageName={page.name}
                  reportTabName={tab.name}
                  reportTabItem={tab}
                  apiEndpoint={apiEndpoint}
                  isActive={
                    selectedReportId === report.id &&
                    selectedReportPageId === page.id &&
                    selectedReportTabId === tab.id &&
                    selectedReportVersionString === version.version
                  }
                />
              ))
            );
          })}
        </GridAreaContent>
      </React.Fragment>
    );
  }
}

export default ReportTabs;
